<template>
  <!-- 最新消息文章页面 -->
  <div class="container">
    <content-template>
      <template slot="left">最新消息</template>
      <template slot="right">
        <li>
          <router-link to="new-message" class="is-check">全部</router-link>
        </li>
        <li><router-link to="events">賽事動態</router-link></li>
        <li><router-link to="activity">其他活動</router-link></li>
      </template>
      <template slot="banner">
        <img src="./banner.png" class="top-banner" alt="">
      </template>
      <template slot="content">
        <div class="contents">
          <div class="time">{{article.published_time}}</div>
          <div class="title">{{article.post_title}}</div>
          <div class="ar-content" v-html="article.post_content"></div>
          <div v-if="article.album_id">
            <img class="col-xs-12 col-sm-3 none-padding article-img" v-for="(album) in article.album_id" :src="album.photo_urls" :key="album.id" preview="1" alt="">
          </div>
        </div>

      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      article: []
    }
  },
  methods: {
    getArticle: function () {
      var that = this
      var id = this.$route.query.id
      this.$axios.get('/portal/articles/' + id)
        .then(function (response) {
          that.article = response.data.data
          that.$previewRefresh()
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.getArticle()
  },
  updated () {
    $('.ar-content img').attr('preview', 2)
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  .contents {
    margin-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .time {
    margin-bottom: 15px;
    font-size: 16px;
    color: #8B8B8B;
  }

  .title {
    margin-bottom: 40px;
    font-size: 25px;
    color: #617BE4;
  }
  .article-img{
    padding: 5px;
    height: 200px;
  }

  @media (max-width: 767px) {
    .time{
      font-size: 14px;
    }
    .title {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/newMessage/article.vue